import { render, staticRenderFns } from "./ReasonsSarsMentionGold.vue?vue&type=template&id=f159392a&"
import script from "./ReasonsSarsMentionGold.vue?vue&type=script&lang=js&"
export * from "./ReasonsSarsMentionGold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports